import { Stack, ThemeProvider } from '@mui/material';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { groupsAccordionTheme } from '@/modules/common/theme';
import { Accordion } from '@common/components/Accordion';
import { InfoText } from '@common/components/InfoText';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';

import { GroupItem } from './GroupItem';

const LayerPropertiesContent = () => {
  const { t } = useTranslation('interface');
  const allGroups = useFloorplanDesignStore((state) => state.uxonly.groups);
  const groupIds = useMemo(() => allGroups.map((g) => g.id), [allGroups]);

  return (
    <ThemeProvider theme={groupsAccordionTheme}>
      <Stack direction='column' spacing={0}>
        {groupIds.length === 0 && (
          <InfoText
            header={t('interface:groups.no_groups_info.header')}
            subHeader={t('interface:groups.no_groups_info.subheader')}
          />
        )}
        {groupIds.map((id) => (
          <GroupItem key={id} id={id} />
        ))}
      </Stack>
    </ThemeProvider>
  );
};

const GroupsPropertiesComponent = () => {
  const { t } = useTranslation('interface');
  const allGroups = useFloorplanDesignStore((state) => state.uxonly.groups);
  const amountOfGroups = allGroups.length;

  return (
    <Accordion
      title={t('interface:groups.header', 'Groups', { count: amountOfGroups })}
      unmountOnExit
      sx={{ px: 2 }}
    >
      <LayerPropertiesContent />
    </Accordion>
  );
};

export const GroupsProperties = memo(GroupsPropertiesComponent);
